import store from "../index.js";
import api from "../../utils/api";
import pageViewAcConstant from "@/mixins/page-view/pageViewAcConstant.js";

export const modules = {
  store,
};

export const state = {};

export const mutations = {};

export const actions = {
  /**
   * 페이지 뷰 기록 endpoint.
   * @param {*} pageName: string 페이지 명.
   * @param {*} pagePath: string 페이지 경로.
   * @param {*} metadata: object 메타데이터.
   */
  async acLogPageView(_, { pageName, pagePath, metadata }) {
    const url = pageViewAcConstant.POST_PAGE_VIEW;
    try {
      const res = await api.post(`${url}`, {
        page_name: pageName,
        page_path: pagePath,
        metadata: JSON.stringify(metadata),
      });
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
